module.exports = function() {
  return new Worker(__webpack_public_path__ + "72937820dbf74e262c8d.worker.js");
};